import React, { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../../components/ToastMsg";
import { addNewDocument } from "../../../../../redux/features/document/documentService";
import BeatLoader from "react-spinners/BeatLoader";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 2MB Limit

const InsertDocument = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fileInputRef = useRef(null);

    const { isDocumentCreating } = useSelector((state) => state.document.newDocument);

    const [formData, setFormData] = useState({});
    const [errorMessages, setErrorMessages] = useState({});

    const validateFile = (file) => {
        if (file) {
            if (!file.type.startsWith("application/pdf")) {
                setErrorMessages({ ...errorMessages, file: "Only pdf files are allowed." });
                return;
            }

            if (file.size > MAX_FILE_SIZE) {
                setErrorMessages({ ...errorMessages, file: "File size exceeds 2MB limit." });
                return;
            }

            setErrorMessages({ ...errorMessages, file: "" });
            setFormData({ ...formData, file });
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const selectedFile = event.dataTransfer.files[0];

        if (selectedFile) {
            validateFile(selectedFile);
        }
    };

    const handleFileChange = (event) => {
        if (event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            validateFile(selectedFile);
        }
    };

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const isValidForm = () => {
        const errors = {};
        if (!formData.name) {
            errors.name = "Name is required.";
        }
        if (!formData.file) {
            errors.file = "Document is required.";
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    };

    const uploadDocument = async () => {
        if (isValidForm()) {
            try {
                const data = {
                    order_id: +id,
                    name: formData.name,
                    file: formData.file
                }
                const response = await dispatch(addNewDocument(data)).unwrap();
                showToast('success', response.message);
                navigate(`/admin/orders/${id}`);
            } catch (error) {
                showToast('error', error.message);
            }
        }

    }
    return (<div className={`card-section`}>
        <div className={`main-card`}>
            <h1 className={`form-title`}>Document</h1>
            <div className={styles.vehicleFormGroup}>
                <div className={`form-input-row`}>
                    <div className={`form-input-col md-col`}>
                        <div className={`form-input-group`}>
                            <label htmlFor='full_name' className={`form-label`}>
                                Name<span className={`required-star`}>*</span>
                            </label>
                            <input
                                type='text'
                                id='name'
                                name='name'
                                value={formData.name || ''}
                                onChange={(e) => {
                                    setErrorMessages({ ...errorMessages, name: "" });
                                    setFormData({ ...formData, name: e.target.value });
                                }}
                                className={`form-input-default`}
                                placeholder="Enter File Name"
                            />
                            {errorMessages.name && (
                                <p className={`text-danger`}>{errorMessages.name}</p>
                            )}
                        </div>
                    </div>
                </div>
                <div className={`form-input-row`}>
                    <div className={`form-input-col`}>
                        <div className={`form-input-group`}>
                            <label htmlFor='full_name' className={`form-label`}>
                                Document<span className={`required-star`}>*</span>
                            </label>
                            <div
                                onDrop={handleDrop}
                                onDragOver={(event) => event.preventDefault()}
                                onClick={handleClick}
                                className={`drop-input`}
                            >
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    accept="application/pdf"
                                    onChange={handleFileChange}
                                    style={{ display: "none" }}
                                />
                                {(!formData.file) ? <p>Drag & Drop a file here or click to select</p>
                                    :
                                    <div className={`inserted-file`}>
                                        <div className={`file-card`}>
                                            <p>{formData.file.name}</p>
                                        </div>
                                    </div>
                                }
                            </div>
                            {errorMessages.file && (
                                <p className={`text-danger`}>{errorMessages.file}</p>
                            )}
                        </div>
                    </div>
                </div>
                <div className={styles.btnSec}>
                    <button
                        className={`btn-primary`}
                        type='button'
                        disabled={isDocumentCreating}
                        onClick={uploadDocument}
                    >
                        {isDocumentCreating ? <BeatLoader /> : `Upload`}
                    </button>
                </div>
            </div>
        </div>
    </div>
    )
}

export default InsertDocument;